import RentalTermsAndConditionsModalContainer from './RentalTermsAndConditionsModalContainer';

export default RentalTermsAndConditionsModalContainer;
